export default "__VITE_ASSET__E0VRzq8q__"